import { GAME_REPORT_REFEREE_REQUESTED, GAMES_REQUESTED, SCORES_REQUESTED, SET_ACTIVE_GAME, SIGN_SUPPLEMENTARY } from '../constants/actionTypes';

export const loadGameReportReferee = ( context, token, gameId ) => {

    return {
        type:    GAME_REPORT_REFEREE_REQUESTED,
        payload: { context, token, gameId }
    };

};

export const loadGames = ( context, token, seasonId ) => {

    return {
        type:    GAMES_REQUESTED,
        payload: { context, token, seasonId }
    };

};

export const loadScores = ( context, gameId ) => {

    return {
        type:    SCORES_REQUESTED,
        payload: { context, gameId }
    };

};

export const setActiveGame = game => {

    return {
        type:    SET_ACTIVE_GAME,
        payload: { game }
    };

};

export const signSupplementary = ( context, token, gameId, team, teamId ) => {

    return {
        type:    SIGN_SUPPLEMENTARY,
        payload: { context, token, gameId, team, teamId }
    };

};